import DefaultToOneTimeShipToState from "@gemeco/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: DefaultToOneTimeShipToState = {
    isDefaultToOneTimeShipToEnabled: false,
};

const reducer = {
    "SetupInitialState/DefaultToOneTimeShipTo": (
        draft: Draft<DefaultToOneTimeShipToState>,
        action: { parameter: DefaultToOneTimeShipToState },
    ) => {
        draft.isDefaultToOneTimeShipToEnabled = action.parameter.isDefaultToOneTimeShipToEnabled;
    },

    "Update/DefaultToOneTimeShipTo": (draft: Draft<DefaultToOneTimeShipToState>) => {
        draft.isDefaultToOneTimeShipToEnabled = !draft.isDefaultToOneTimeShipToEnabled;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);